import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { LaunchDarklyService } from '@app/core/feature-flags/launchdarkly.service';
import { StateService } from '@app/shared/state.service';

@Component({
  selector: 'om-address-basic-input',
  templateUrl: './address-basic-input.component.html',
  styleUrls: ['../../form-input.scss'],
})
export class AddressBasicInputComponent implements OnInit {
  @Input() address: UntypedFormGroup;
  @Input() isRpcEligible = false;

  constructor(private launchDarklyService: LaunchDarklyService, public stateService: StateService) {}

  ngOnInit() {
    if (this.isRpcEligible) {
      this.updateFieldsDisabledState();
    }
  }

  private updateFieldsDisabledState() {
    if (!this.address) {
      return;
    }
    const fieldNames = ['state', 'zip'];
    fieldNames.forEach(fieldName => {
      const control = this.address.get(fieldName);
      if (control) {
        control.disable();
      }
    });
  }
}
